<template lang="pug">
  div
    flex-body(:rows="doc.acf.installation.article_body")
</template>

<script>
import FlexBody from '@/components/FlexBody/FlexBody'
import FurtherReading from '@/components/FurtherReading'
export default {
  name: 'Overview',
  props: ['doc'],
  components: { FlexBody, FurtherReading },
  mounted () {
    console.log(this.doc.acf.installation.article_body)
  }
}
</script>

<style>
</style>
